import { LOGIN_ROOT, DEFAULT_HOME_ROOT } from "src/route_constants";

export const Routes = {
    login: LOGIN_ROOT,
    signup: DEFAULT_HOME_ROOT
}
